/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API - V2 Redesigned
 * Redesigned API endpoints (v2) for better performance with smaller, functional DTOs. Each endpoint provides only the data needed for specific UI components/tabs.  V2 endpoints are designed to replace heavy monolithic v1 endpoints: - Reduced response sizes by 80-95% - Component-specific data loading - Pagination and filtering support - Optimized for mobile and slow connections 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Current lifecycle status of the tournament
 * @export
 * @enum {string}
 */
export enum TournamentStatus {
    Scheduled = 'SCHEDULED',
    Registration = 'REGISTRATION',
    Preparation = 'PREPARATION',
    InProgress = 'IN_PROGRESS',
    Finished = 'FINISHED',
    Inactive = 'INACTIVE'
}


export function instanceOfTournamentStatus(value: any): boolean {
    for (const key in TournamentStatus) {
        if (Object.prototype.hasOwnProperty.call(TournamentStatus, key)) {
            if (TournamentStatus[key as keyof typeof TournamentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentStatusFromJSON(json: any): TournamentStatus {
    return TournamentStatusFromJSONTyped(json, false);
}

export function TournamentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentStatus {
    return json as TournamentStatus;
}

export function TournamentStatusToJSON(value?: TournamentStatus | null): any {
    return value as any;
}

export function TournamentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentStatus {
    return value as TournamentStatus;
}

